import { HStack } from '@rbilabs/universal-components';

export const StoreCardActionsContainer = HStack.withConfig({
  justifyContent: 'flex-end',
});

export const FallbackWrapper = HStack.withConfig({
  justifyContent: 'center',
  alignItems: 'center',
  padding: '$1',
});
